import React, { useEffect, useState } from 'react'
import moment from 'moment'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import NewUserForm from '~/Common-Objects/NewUserForm/newUserForm.jsx'
import Row from '~/Common-Objects/Grids/Row/Row'
import StickyNavBottom from '~/Common-Objects/Navigation/StickNavBottom'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import UpsellModal from '~/Common-Objects/UpsellModal'
import axios from '~/data/http/axios'
import helpers from '~/Classes/helpers'
import SendPreview from './preview'
import SendAnalysis from './analysis'
import SendStartTime from './startTime'
import SendRecipients from './recipients'
import Summary from './summary'
import SendGroupSubscribers from './subscribers'
import i18n from '~/i18n'
import { useHistory } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import { alterSiteDrawer } from '~/data/actions/siteActions'
import numberFormatFunctions from '~/Classes/numberFormatFunctions'
import ViewSubs from '../../steps/step1/viewSubs'
import { useHasMergeTags } from '../hooks'
import CampaignSendNow from '../../steps/step3/sendNow'
import { alterFullpage } from '../../../../../../data/actions/siteActions'
import postHogFunctions from '~/Classes/posthog'
import AccountApprovalRequired from '~/Common-Objects/Account/AccountApprovalRequired'
import Step3Advanced from '../../steps/step3/advanced'

export default function SmsSend({
    campaign,
    subscriberCount = 0,
    sendingLimitReached = false,
    checkSendingLimit = () => {},
    updateCampaign = () => {},
    saveCampaign = () => {},
    changeStep = () => {}
}) {
    const [plans, setPlans] = useState(null)
    const [analysis, setAnalysis] = useState(null)
    const [template, setTemplate] = useState(null)
    const [canStart, setCanStart] = useState(false)
    const [errors, setErrors] = useState([])
    const [approveDrawer, setApproveDrawer] = useState(null)
    const [showAdvanced, setShowAdvanced] = useState(
        campaign.limit || (campaign.batchSize && campaign.batchUnit && campaign.batchDelay)
    )
    const history = useHistory()
    const siteMaster = useSelector((state) => state.siteMaster)
    const accountMaster = useSelector((state) => state.accountMaster)
    const dispatch = useDispatch()
    const hasMergeTags = useHasMergeTags(template?.templateHTML)

    const analyseSend = async () => {
        const res = await axios.get('/campaign/' + campaign.id + '/sms/estimate')
        setAnalysis(res.data)
    }

    const send = async (sendImmediately = false) => {
        dispatch(alterFullpage(null))
        if (canStart) {
            try {
                setErrors([])
                await saveCampaign()
                await axios.put('/campaign/' + campaign.id + '/start')
                postHogFunctions.capture('sms_campaign_started', {
                    recipients: subscriberCount,
                    characters: template?.templateHTML?.length,
                    publish: sendImmediately ? 'immediately' : 'scheduled'
                })
                history.push('/cp/campaigns/add/finished/' + campaign.id)
            } catch (err) {
                setErrors([
                    {
                        value: err.data.error,
                        click:
                            siteMaster.hidePricing || accountMaster.accountMaster.invoice
                                ? () => {}
                                : () => history.push('/cp/company/subscription')
                    }
                ])
            }
        }
    }

    const sendNow = () => {
        if (canStart) {
            const count =
                campaign.limit && campaign.limit > 0 && subscriberCount > campaign.limit
                    ? campaign.limit
                    : subscriberCount
            const modal = (
                <CampaignSendNow
                    count={count}
                    onConfirm={() => {
                        send(true)
                    }}
                    onCancel={() => dispatch(alterFullpage(null))}
                />
            )
            dispatch(alterFullpage(modal))
        }
    }

    const save = async (step) => {
        await saveCampaign()
        if (step && parseInt(step)) {
            changeStep(step)
        } else {
            history.push('/cp/campaigns')
        }
    }

    const activate = () => {
        var theDrawer = (
            <NewUserForm
                from='campaign'
                finish={() => {
                    setApproveDrawer(null)
                }}
            />
        )
        setApproveDrawer(theDrawer)
    }

    const viewSubs = () => {
        var drawerContent = (
            <ViewSubs
                campaign={campaign}
                segments={campaign.Segments}
                groups={campaign.Groups}
                count={subscriberCount}
            />
        )
        dispatch(alterSiteDrawer(true, true, 'right', drawerContent, true, '100%'))
    }

    const addSms = () => {
        const modal = (
            <UpsellModal
                feature='sms'
                plans={plans}
                onUpgrade={() => {
                    dispatch(alterFullpage(null))
                }}
            />
        )
        dispatch(alterFullpage(modal))
    }

    useEffect(() => {
        analyseSend()
        axios.get('/template/' + campaign.TemplateId).then((res) => {
            setTemplate(res.data.template)
        })
        axios.get('/accountMaster/plan?type=2').then((res) => setPlans(res.data.Plans))
    }, [])

    if (!analysis || !template || !plans?.length) return <LoadingIcons iconType='2' />

    const result = helpers.getSmsCredits(campaign, template)

    const sendingNow = moment(campaign.startDate) <= moment()

    const hasSmsPlan = !!accountMaster.accountMaster.SmsAccountBillingId
    const cheapestPlan = plans.reduce((prev, curr) => {
        return prev.friendlyPriceRaw < curr.friendlyPriceRaw ? prev : curr
    })
    let price = cheapestPlan.price + '/' + (accountMaster.accountMaster.billingFrequency === 0 ? 'month' : 'year')
    if (accountMaster.accountMaster.billingFrequency === 1) {
        // annual so times it by 12
        price = cheapestPlan.price * 12 + '/year'
    }

    return (
        <>
            <Row>
                <Column xs={12} sm={8}>
                    <SendStartTime campaign={campaign} updateCampaign={updateCampaign} />
                    <SendRecipients campaign={campaign} />
                    <div
                        className=''
                        style={{ alignItems: 'center', display: 'flex', cursor: 'pointer', width: 'auto' }}
                        onClick={() => setShowAdvanced(!showAdvanced)}
                    >
                        <Toggle
                            checked={showAdvanced}
                            className='mar-r5 cyt-advance-toggle'
                            onChange={() => {}}
                        />
                        Advanced Settings
                    </div>
                    <Step3Advanced
                        campaign={campaign}
                        saveCampaign={saveCampaign}
                        updateCampaign={updateCampaign}
                        show={showAdvanced}
                        totalSubs={subscriberCount}
                    />
                </Column>

                <Column xs={12} sm={4}>
                    <SendGroupSubscribers campaign={campaign} subscriberCount={subscriberCount} save={viewSubs} />
                    <SendPreview campaign={campaign} content={template.templateHTML} edit={() => save(2)} />
                    <SendAnalysis
                        campaign={campaign}
                        analysis={analysis}
                        messages={result.messages}
                        hasMergeTags={hasMergeTags}
                    />
                    <Summary
                        campaign={campaign}
                        messages={result.messages}
                        template={template}
                        subscriberCount={subscriberCount}
                        sendingLimitReached={sendingLimitReached}
                        checkSendingLimit={checkSendingLimit}
                        setCanStart={setCanStart}
                        saveErrors={errors}
                        changeStep={changeStep}
                    />
                </Column>

                <StickyNavBottom>
                    <Column xs={12} sm={12} className='text-center'>
                        <div className='flexSpaceBetween'>
                            <div className='quickFlex'>
                                <Button
                                    className='mar-r15'
                                    onClick={() => save(2)}
                                    iconLeft={<Icons icon='arrowLeft' />}
                                >
                                    Back
                                </Button>
                                <Button onClick={() => save()}>
                                    {i18n.t('campaigns:standard.step3.save')}
                                </Button>
                            </div>

                            <AccountApprovalRequired
                                notApprovedText={'Account approval is required to send campaigns'}
                                inReviewText={'Your account is under review'}
                                messageOrientation={'left'}
                                activateFrom={'campaign'}
                                approvedAction={
                                    <Button
                                        className='button-primary'
                                        iconRight={hasSmsPlan && <Icons icon='arrowRight' />}
                                        iconLeft={!hasSmsPlan && <Icons icon='chevronsUp' />}
                                        onClick={hasSmsPlan ? (sendingNow ? sendNow : send) : addSms}
                                        disabled={!canStart}
                                        postHogTag='sms-upsell-campaign-3-add'
                                    >
                                        {sendingNow &&
                                            hasSmsPlan &&
                                            i18n.t('campaigns:standard.step3.sendImmediate', {
                                                total: numberFormatFunctions.formatNumber(subscriberCount)
                                            })}
                                        {!sendingNow &&
                                            hasSmsPlan &&
                                            i18n.t('campaigns:standard.step3.sendSchedule', {
                                                total: numberFormatFunctions.formatNumber(subscriberCount)
                                            })}

                                        {!hasSmsPlan && (
                                            <>
                                                Add SMS from {cheapestPlan.symbol}
                                                {price}
                                            </>
                                        )}
                                    </Button>
                                }
                            />
                        </div>
                    </Column>
                </StickyNavBottom>
            </Row>
            {approveDrawer}
        </>
    )
}
